import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupNotifications extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      data: {},
      loading: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "notifications",
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._probe_setup_form.init({
                notifications: data,
              });
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    //  console.log("DEBUG :: ProbeSetup _ saveProbeSetup");
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "notifications",
            value: data["notifications"],
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //		console.log("DEBUG :: ProbeSetupEthernet _ onComponentDidMount");
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="Ethernet"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            preInit={(data) => {
              if (!data.notifications) {
                data.notifications = {};
              }
              return data;
            }}
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
          >
            <Row>
              <Col xs={12}>
                {/* <Row className="mb-3">
                  <Col xs={12} sm={6} lg={6}>
                    <ReactOFormInput
                      type="switch"
                      label="Mail notifications about probe reachability (syncs)"
                      data_key="notifications.enable"
                      size="sm"
                      default="no"
                      switchOnValue="yes"
                      switchOffValue="no"
                    />
                  </Col>
                </Row> */}
                <Row className="mb-3">
                  <Col xs={12} sm={6} lg={6}>
                    <ReactOFormInput
                      type="text"
                      data_key="notifications.mail"
                      // disabledIf={(form_data) => {
                      //   return (
                      //     this._probe_setup_form.getEntry("notifications.enable") == "no"
                      //   );
                      // }}
                      label="SEND MAIL TO"
                      size="md"
                      default=""
                      help="Use a comma to separate more mail address"
                      placeholder="e.g. mail@example.com, mail@example.com"
                      validators={[
                        {
                          func: (value) => {
                            return (
                              (this._probe_setup_form.getEntry("notifications.enable") ==
                                "no" &&
                                value == "") ||
                              /^(?:[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){1}(?:\,\s[\w.-]+\@[\w-]+\.?[\w-]+\.{1}[a-zA-Z]+){0,}$/i.test(
                                value
                              )
                            );
                          },
                          invalid_text: "Type a valid mail address",
                        },
                      ]}
                    />
                  </Col>
                </Row>

                <ReactOActionBar align="right" padding="0">
                  <ReactOFormInput type="submit" value="Save" color="primary" icon="save">
                    Save
                  </ReactOFormInput>
                </ReactOActionBar>
              </Col>
            </Row>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(withRouter(ProbeSetupNotifications), {
  define: null,
});
